import { h, Component } from 'preact';
import s from 'components/bolt/main/introPopUp/introPopUp.sss';
import { joinClasses } from 'utils/utils';
import Store from 'store/store';

export default class IntroPopUp extends Component {
	constructor(props) {
		super(props);
		this.props = props;

		this.onPlay = this.onPlay.bind(this);
		this.onPause = this.onPause.bind(this);
		this.onEnded = this.onPause.bind(this);
		this.handleClose = this.handleClose.bind(this);
		this.progressTracker = this.progressTracker.bind(this);

		this.$video;
		this.progressTracking = {};
		this.timer;
		this.videoIsPlaying = false;
	}

	componentWillUnmount() {
		cancelAnimationFrame(this.timer);
	}

	onPlay() {
		this.videoIsPlaying = true;
		this.progressTracking = {};
		this.progressTracker();
	}

	onPause() {
		this.videoIsPlaying = false;
		// this.props.onClose();
		this.$video.pause();
		cancelAnimationFrame(this.timer);
	}

	handleClose() {
		this.videoIsPlaying = false;
		this.props.onClose();
		this.$video.pause();
		cancelAnimationFrame(this.timer);
	}


	progressTracker() {
		if (!this.$video || !this.videoIsPlaying ) {
			return;
		}
		const progress = this.$video.currentTime / this.$video.duration;
		let step = [0, 25, 50, 75, 95].find(step => progress > (step / 100) && !this.progressTracking[step]);

		if (step || step === 0) {
			this.progressTracking[step] = true;

			Store.emit('CUSTOM_EVENT', {
				category: 'central-navigation',
				action: 'intro-video-playback',
				label: `${step} percentage completion`
			});
		}

		this.timer = requestAnimationFrame(this.progressTracker);
	}


	render() {
		const { imageRoot, videoRegionRoot, isOpen } = this.props;
		if (isOpen) {
			this.$video.play();
		}
		return (
			<div class={joinClasses(s.container, isOpen && s.open)}>
				<div class={joinClasses(s.panel, isOpen && s.open)}>
					<button class={s.closeVideoButton} onClick={this.handleClose}>
						<img src={`${imageRoot}/closebtn.webp`} />
						<img class={s.hoverCloseBtnImg} src={`${imageRoot}/hjmp3s.webp`} />
					</button> 
					<div class={s.videoContainer}>
						<video ref={video => this.$video = video} muted={false} playsinline controls class={s.video} onEnded={this.handleClose} onPlay={this.onPlay} onPause={this.onPause} preload="auto" poster={`${imageRoot}/oj2b6s.webp`}>
							<source src={`${videoRegionRoot}/oj2b6s.mp4`} type={'video/mp4'} />
							<source src={`${videoRegionRoot}/oj2b6s.webm`} type={'video/webm'} />
						</video> 
					</div>
				</div>
			</div>
		);
	}
}
